// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2fSFA","disabled":"FileBtn_disabled__3l2sJ","warn":"FileBtn_warn__147Pz","fade":"FileBtn_fade__3qlfx"};